module.exports = __webpack_public_path__ + "img/afes.4d24c6db.png";